import {
  createManualTaxMapping as publicCreateManualTaxMapping,
  bulkCreateManualTaxMappings as publicBulkCreateManualTaxMappings,
  getManualTaxMapping as publicGetManualTaxMapping,
  updateManualTaxMapping as publicUpdateManualTaxMapping,
  deleteManualTaxMapping as publicDeleteManualTaxMapping,
  queryManualTaxMappings as publicQueryManualTaxMappings,
  typedQueryManualTaxMappings as publicTypedQueryManualTaxMappings,
  updateExtendedFields as publicUpdateExtendedFields,
  bulkAssignExemptOverrides as publicBulkAssignExemptOverrides,
  bulkUnassignExemptOverrides as publicBulkUnassignExemptOverrides,
  listManualTaxMappings as publicListManualTaxMappings,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ManualTaxMappingQuery,
  ManualTaxMappingsQueryBuilder,
  typedQueryManualTaxMappings as universalTypedQueryManualTaxMappings,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';
import { onManualTaxMappingCreated as publicOnManualTaxMappingCreated } from './billing-v1-manual-tax-mapping-manual-tax-mappings.public.js';
import { onManualTaxMappingDeleted as publicOnManualTaxMappingDeleted } from './billing-v1-manual-tax-mapping-manual-tax-mappings.public.js';
import { onManualTaxMappingUpdated as publicOnManualTaxMappingUpdated } from './billing-v1-manual-tax-mapping-manual-tax-mappings.public.js';

function customQueryManualTaxMappings(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryManualTaxMappings(httpClient)(),
    typedQueryFunction: (query: ManualTaxMappingQuery) =>
      publicTypedQueryManualTaxMappings(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ManualTaxMappingsQueryBuilder;
  function overloadedQuery(
    query: ManualTaxMappingQuery
  ): ReturnType<typeof universalTypedQueryManualTaxMappings>;
  function overloadedQuery(query?: ManualTaxMappingQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createManualTaxMapping: MaybeContext<
  BuildRESTFunction<typeof publicCreateManualTaxMapping> &
    typeof publicCreateManualTaxMapping
> = /*#__PURE__*/ createRESTModule(publicCreateManualTaxMapping);
export const bulkCreateManualTaxMappings: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateManualTaxMappings> &
    typeof publicBulkCreateManualTaxMappings
> = /*#__PURE__*/ createRESTModule(publicBulkCreateManualTaxMappings);
export const getManualTaxMapping: MaybeContext<
  BuildRESTFunction<typeof publicGetManualTaxMapping> &
    typeof publicGetManualTaxMapping
> = /*#__PURE__*/ createRESTModule(publicGetManualTaxMapping);
export const updateManualTaxMapping: MaybeContext<
  BuildRESTFunction<typeof publicUpdateManualTaxMapping> &
    typeof publicUpdateManualTaxMapping
> = /*#__PURE__*/ createRESTModule(publicUpdateManualTaxMapping);
export const deleteManualTaxMapping: MaybeContext<
  BuildRESTFunction<typeof publicDeleteManualTaxMapping> &
    typeof publicDeleteManualTaxMapping
> = /*#__PURE__*/ createRESTModule(publicDeleteManualTaxMapping);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const bulkAssignExemptOverrides: MaybeContext<
  BuildRESTFunction<typeof publicBulkAssignExemptOverrides> &
    typeof publicBulkAssignExemptOverrides
> = /*#__PURE__*/ createRESTModule(publicBulkAssignExemptOverrides);
export const bulkUnassignExemptOverrides: MaybeContext<
  BuildRESTFunction<typeof publicBulkUnassignExemptOverrides> &
    typeof publicBulkUnassignExemptOverrides
> = /*#__PURE__*/ createRESTModule(publicBulkUnassignExemptOverrides);
export const listManualTaxMappings: MaybeContext<
  BuildRESTFunction<typeof publicListManualTaxMappings> &
    typeof publicListManualTaxMappings
> = /*#__PURE__*/ createRESTModule(publicListManualTaxMappings);
export const queryManualTaxMappings: MaybeContext<
  BuildRESTFunction<typeof customQueryManualTaxMappings> &
    typeof customQueryManualTaxMappings
> = /*#__PURE__*/ createRESTModule(customQueryManualTaxMappings);
/**
 * Triggered when a manual tax mapping is created.
 */
export const onManualTaxMappingCreated: BuildEventDefinition<
  typeof publicOnManualTaxMappingCreated
> &
  typeof publicOnManualTaxMappingCreated = /*#__PURE__*/ createEventModule(
  publicOnManualTaxMappingCreated
);
/**
 * Triggered when a manual tax mapping is deleted.
 */
export const onManualTaxMappingDeleted: BuildEventDefinition<
  typeof publicOnManualTaxMappingDeleted
> &
  typeof publicOnManualTaxMappingDeleted = /*#__PURE__*/ createEventModule(
  publicOnManualTaxMappingDeleted
);
/**
 * Triggered when a manual tax mapping is updated.
 */
export const onManualTaxMappingUpdated: BuildEventDefinition<
  typeof publicOnManualTaxMappingUpdated
> &
  typeof publicOnManualTaxMappingUpdated = /*#__PURE__*/ createEventModule(
  publicOnManualTaxMappingUpdated
);

export {
  JurisdictionType,
  SortOrder,
  WebhookIdentityType,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';
export {
  ManualTaxMapping,
  ExemptDetails,
  ExtendedFields,
  CreateManualTaxMappingRequest,
  CreateManualTaxMappingResponse,
  BulkCreateManualTaxMappingsRequest,
  BulkCreateManualTaxMappingsResponse,
  ItemMetadata,
  ApplicationError,
  BulkManualTaxMappingResult,
  BulkActionMetadata,
  GetManualTaxMappingRequest,
  GetManualTaxMappingResponse,
  UpdateManualTaxMappingRequest,
  UpdateManualTaxMappingResponse,
  DeleteManualTaxMappingRequest,
  DeleteManualTaxMappingResponse,
  QueryManualTaxMappingsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryManualTaxMappingsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  BulkRestoreManualTaxMappingsRequest,
  BulkRestoreManualTaxMappingsResponse,
  BulkRestoreManualTaxMappingsResult,
  BulkAssignExemptOverridesRequest,
  AssignOverride,
  ExemptGroupIdOverride,
  BulkAssignExemptOverridesResponse,
  BulkExemptOverrideResult,
  BulkUnassignExemptOverridesRequest,
  UnassignOverride,
  BulkUnassignExemptOverridesResponse,
  ListManualTaxMappingsRequest,
  ListManualTaxMappingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ManualTaxMappingCreatedEnvelope,
  ManualTaxMappingDeletedEnvelope,
  ManualTaxMappingUpdatedEnvelope,
  BulkCreateManualTaxMappingsOptions,
  UpdateManualTaxMapping,
  ManualTaxMappingsQueryResult,
  ManualTaxMappingsQueryBuilder,
  ManualTaxMappingQuerySpec,
  UpdateExtendedFieldsOptions,
  BulkAssignExemptOverridesOptions,
  BulkUnassignExemptOverridesOptions,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';
export { utils } from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';
export {
  JurisdictionTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateManualTaxMappingApplicationErrors,
  UpdateManualTaxMappingApplicationErrors,
  CommonQueryWithEntityContext,
  ManualTaxMappingQuery,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';
